<div class="page page-dashboard">
    <div class="page_header">
        <h1 class="page_title">Dashboard</h1>
    </div>
    <div class="page_padding">
        <div class="d-flex w-100">
            <div class="page-dashboard-panel" [class.active]="panel === 1" (click)="panel = 1">
                <a href="javascript:void(0)">
                    <h4 class="text-primary">{{ 'dashboard.committeeTab' | translate }}</h4>
                </a>
            </div>
            <div class="page-dashboard-panel" [class.active]="panel === 2" (click)="panel = 2">
                <a href="javascript:void(0)">
                    <h4 class="text-primary">{{ 'dashboard.performanceTab' | translate }}</h4>
                </a>
            </div>
        </div>
        <div class="block mt-5">
            <ng-container *ngIf="panel === 1">
                <!-- Filtros exibidos nesta aba: País, Comitê, Desafio, Status, Ano (o filtro Mês foi removido a pedido da cliente).
                     A query NÃO aceita filtro de Unidade — por isso o select de unidade foi removido desta aba
                     (unidade só vale na aba "Performance Geral"). -->
                <div class="page_filter mb-4">
                    <div class="input-material">
                        <select id="country" class="form-control" name="country" [(ngModel)]="filterCountryId">
                            <option [ngValue]="undefined">{{ 'minhalista.input3.subtitle' | translate }}</option>
                            <option *ngFor="let u of listCountry" [value]="u.id">{{ u.name }}</option>
                        </select>
                        <label for="country" class="mb-0 mr-3">{{ 'dashboard.committee.filters.country' | translate }}</label>
                    </div>
                    <div class="input-material">
                        <select id="committee" class="form-control" name="committee" [(ngModel)]="filterCommitteeId">
                            <option [ngValue]="undefined">{{ 'minhalista.input3.subtitle' | translate }}</option>
                            <option *ngFor="let u of committeeResult" [value]="u.id">{{ u.name }}</option>
                        </select>
                        <label for="committee" class="mb-0 mr-3">{{ 'committee' | translate }}</label>
                    </div>
                    <div class="input-material">
                        <select id="challenge" class="form-control" name="challenge" [(ngModel)]="filterChallengeId">
                            <option [ngValue]="undefined">{{ 'minhalista.input3.subtitle' | translate }}</option>
                            <option *ngFor="let c of challengeResult" [value]="c.id">{{ c.title }}</option>
                        </select>
                        <label for="challenge" class="mb-0 mr-3">{{ 'dashboard.committee.filters.challenge' | translate }}</label>
                    </div>
                    <div class="input-material">
                        <select id="status" class="form-control" name="status" [(ngModel)]="filterStatus">
                            <option [ngValue]="undefined">{{ 'minhalista.input3.subtitle' | translate }}</option>
                            <option *ngFor="let s of dashboardStatuses" [value]="s">{{ 'dashboard.committee.status.' + s | translate }}</option>
                        </select>
                        <label for="status" class="mb-0 mr-3">{{ 'dashboard.committee.filters.status' | translate }}</label>
                    </div>
                    <div class="input-material mr-auto">
                        <select id="year" class="form-control" name="year" [(ngModel)]="filterYear">
                            <option [ngValue]="undefined">{{ 'minhalista.input3.subtitle' | translate }}</option>
                            <option *ngFor="let y of yearsList" [value]="y">{{ y }}</option>
                        </select>
                        <label for="year" class="mb-0 mr-3">{{ 'dashboard.committee.filters.year' | translate }}</label>
                    </div>
                    <div class="page_filter_action flex-grow-1" style="max-width: 109px;">
                        <a href="javascript:void(0)"
                           (click)="onSearch()"
                           class="btn btn-block btn-lg btn-primary btn-search"
                           style="font-weight: normal;"
                           type="button">{{ 'dashboard.committee.search' | translate }}</a>
                    </div>
                </div>
                <div class="d-block mt-4 px-4">
                    <h3 class="text-primary"><strong>{{ 'dashboard.committee.committeesTitle' | translate }}</strong></h3>

                    <div class="page-dashboard-card-list page-dashboard-card-list-committee">
                        <div class="page-dashboard-card page-dashboard-card-light"
                             *ngFor="let c of committeeDashboard?.all?.committees">
                            <div class="page-dashboard-card-header">
                                <div class="page-dashboard-card-icon">
                                    <svg-icon src="assets/svg/wb_incandescent.svg"></svg-icon>
                                </div>
                                <strong class="page-dashboard-card-value">{{ c.total }}</strong>
                            </div>
                            <span class="page-dashboard-card-title">{{ c.label }}</span>
                        </div>
                    </div>
                </div>
                <div class="d-block mt-4 px-4">
                    <h3 class="text-primary"><strong>{{ 'dashboard.committee.ideasTitle' | translate }}</strong></h3>

                    <div class="page-dashboard-card-list page-dashboard-card-list-idea">
                        <!-- Cards reais vêm de all.ideas (por key); cards com s.mock = dado ilustrativo (sem fonte no backend). -->
                        <div class="page-dashboard-card page-dashboard-card-light page-dashboard-card-small"
                             *ngFor="let s of statusCards"
                             [class.page-dashboard-card-mock]="s.mock"
                             [attr.title]="s.mock ? ('dashboard.committee.mockHint' | translate) : null">
                            <div class="page-dashboard-card-header">
                                <div class="page-dashboard-card-icon">
                                    <svg-icon src="assets/svg/group.svg"></svg-icon>
                                </div>
                                <strong class="page-dashboard-card-value">{{ s.mock ? '—' : s.total }}</strong>
                            </div>

                            <span class="page-dashboard-card-title">{{ s.label || (s.labelKey | translate) }}</span>
                            <span class="page-dashboard-card-mock-badge" *ngIf="s.mock">{{ 'dashboard.committee.mockBadge' | translate }}</span>
                        </div>
                    </div>
                </div>

                <div class="d-block mt-4 px-4">
                    <h3 class="text-primary"><strong>{{ 'dashboard.committee.chartTitle' | translate }}</strong></h3>
                </div>
                <div class="page-dashboard-chart-wrap">
                    <google-chart
                            class="my-4"
                            style="width: 100%; display: block;"
                            [type]="chart.type"
                            [data]="chart.data"
                            [columns]="chart.columns"
                            [options]="chart.options"
                            [dynamicResize]="true">
                    </google-chart>
                </div>

                <div class="page-dashboard-idea-list">
                    <div class="page-dashboard-idea-header">
                        <h3 class="page-dashboard-idea-title">{{ 'dashboard.committee.ideaList' | translate }}</h3>
                        <span class="page-dashboard-idea-total">{{ listPage?.totalCount || 0 }}</span>
                    </div>

                    <div class="page-dashboard-idea-divider"></div>

                    <div class="page-dashboard-table-scroll">
                    <div class="page-dashboard-idea-table">
                        <div class="page-dashboard-idea-table-head">
                            <div>{{ 'dashboard.committee.cols.code' | translate }}</div>
                            <div>{{ 'dashboard.committee.cols.title' | translate }}</div>
                            <div>{{ 'dashboard.committee.cols.responsible' | translate }}</div>
                            <div>{{ 'dashboard.committee.cols.unity' | translate }}</div>
                            <div></div>
                        </div>

                        <div class="page-dashboard-idea-table-body">
                            <div
                                    class="page-dashboard-idea-table-row"
                                    *ngFor="let idea of listPage?.results; let i = index"
                                    [class.striped]="i % 2 !== 0">
                                <div class="page-dashboard-idea-table-code">{{ idea.code }}</div>
                                <div class="page-dashboard-idea-table-title-text">{{ idea.title }}</div>
                                <div class="page-dashboard-idea-table-responsible">{{ idea.responsible }}</div>
                                <div class="page-dashboard-idea-table-unity">{{ idea.unity }}</div>
                                <div class="page-dashboard-idea-table-action">
                                    <a href="javascript:void(0)">›</a>
                                </div>
                            </div>
                        </div>
                    </div>
                    </div>

                    <div class="page-dashboard-idea-pagination d-flex align-items-center justify-content-end mt-3"
                         *ngIf="listPage">
                        <button type="button" class="btn btn-sm btn-outline-primary mr-2"
                                [disabled]="!listPage.previouPage" (click)="prevPage()">‹</button>
                        <span class="mx-2">{{ listPage.currentPage }} / {{ listPage.totalPage }}</span>
                        <button type="button" class="btn btn-sm btn-outline-primary ml-2"
                                [disabled]="!listPage.nextPage" (click)="nextPage()">›</button>
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="panel === 2">
                <!-- Filtros compartilhados desta aba (Unidade/Comitê/Status/Período) montam UM
                     SearchGeneralPerformanceDashboardInput; "Pesquisar" dispara as 5 queries.
                     País e Ano são apenas visuais nesta fase (o input não tem country/year) — tooltip "em breve".
                     O campo de texto "Busca" do mock foi removido por não ter parâmetro. -->
                <div class="page_filter mb-4">
                    <div class="input-material" [attr.title]="'dashboard.performance.filterSoon' | translate">
                        <select id="perfCountry" class="form-control" name="perfCountry" [(ngModel)]="perfCountryId">
                            <option [ngValue]="undefined">{{ 'minhalista.input3.subtitle' | translate }}</option>
                            <option *ngFor="let u of listCountry" [value]="u.id">{{ u.name }}</option>
                        </select>
                        <label for="perfCountry" class="mb-0 mr-3">{{ 'dashboard.performance.country' | translate }} <small class="page-dashboard-filter-soon">({{ 'dashboard.performance.soon' | translate }})</small></label>
                    </div>
                    <div class="input-material">
                        <select id="perfUnity" class="form-control" name="perfUnity" [(ngModel)]="perfUnityId">
                            <option [ngValue]="undefined">{{ 'minhalista.input3.subtitle' | translate }}</option>
                            <option *ngFor="let u of listUnity" [value]="u.id">{{ u.name }}</option>
                        </select>
                        <label for="perfUnity" class="mb-0 mr-3">{{ 'unity' | translate }}</label>
                    </div>
                    <div class="input-material">
                        <select id="perfCommittee" class="form-control" name="perfCommittee" [(ngModel)]="perfCommitteeId">
                            <option [ngValue]="undefined">{{ 'minhalista.input3.subtitle' | translate }}</option>
                            <option *ngFor="let c of committeeResult" [value]="c.id">{{ c.name }}</option>
                        </select>
                        <label for="perfCommittee" class="mb-0 mr-3">{{ 'committee' | translate }}</label>
                    </div>
                    <div class="input-material">
                        <select id="performanceStatus" class="form-control" name="performanceStatus"
                                [(ngModel)]="performanceStatus">
                            <option [ngValue]="undefined">{{ 'minhalista.input3.subtitle' | translate }}</option>
                            <option *ngFor="let s of dashboardStatuses" [value]="s">{{ 'dashboard.committee.status.' + s | translate }}</option>
                        </select>
                        <label for="performanceStatus" class="mb-0 mr-3">{{ 'dashboard.committee.filters.status' | translate }}</label>
                    </div>
                    <div class="input-material" [attr.title]="'dashboard.performance.filterSoon' | translate">
                        <select id="perfYear" class="form-control" name="perfYear" [(ngModel)]="perfYear">
                            <option [ngValue]="undefined">{{ 'minhalista.input3.subtitle' | translate }}</option>
                            <option *ngFor="let y of yearsList" [value]="y">{{ y }}</option>
                        </select>
                        <label for="perfYear" class="mb-0 mr-3">{{ 'dashboard.performance.year' | translate }} <small class="page-dashboard-filter-soon">({{ 'dashboard.performance.soon' | translate }})</small></label>
                    </div>
                    <div class="input-material">
                        <input id="perfStartDate" class="form-control" type="date" [(ngModel)]="perfStartDate" name="perfStartDate"/>
                        <label for="perfStartDate" class="mb-0 mr-3">{{ 'dashboard.performance.startDate' | translate }}</label>
                    </div>
                    <div class="input-material mr-auto">
                        <input id="perfEndDate" class="form-control" type="date" [(ngModel)]="perfEndDate" name="perfEndDate"/>
                        <label for="perfEndDate" class="mb-0 mr-3">{{ 'dashboard.performance.endDate' | translate }}</label>
                    </div>
                    <div class="page_filter_action flex-grow-1" style="max-width: 109px;">
                        <a href="javascript:void(0)"
                           (click)="onSearchPerformance()"
                           class="btn btn-block btn-lg btn-primary btn-search"
                           style="font-weight: normal;"
                           type="button">{{ 'dashboard.performance.searchBtn' | translate }}</a>
                    </div>
                </div>

                <div class="page-dashboard-card-list page-dashboard-card-list-three">

                    <div class="page-dashboard-card page-dashboard-card-primary">
                        <div class="page-dashboard-card-header">
                            <div class="page-dashboard-card-icon">
                                <svg-icon src="assets/svg/wb_incandescent.svg"></svg-icon>
                            </div>
                            <strong class="page-dashboard-card-value">{{ generalPerformance?.ideasRegistered || 0 }}</strong>
                        </div>
                        <span class="page-dashboard-card-title">{{ 'dashboard.performance.ideasRegistered' | translate }}</span>
                    </div>

                    <div class="page-dashboard-card page-dashboard-card-light">
                        <div class="page-dashboard-card-header align-items-start">
                            <div class="page-dashboard-card-icon">
                                <svg-icon src="assets/svg/paid.svg"></svg-icon>
                            </div>
                            <div class="text-right">
                                <strong class="page-dashboard-card-value">{{ 'dashboard.performance.brazil' | translate }} | {{ generalPerformance?.awardedIdeasBrazil || 0 }}</strong>
                                <p class="page-dashboard-card-value">{{ 'dashboard.performance.latam' | translate }} | {{ generalPerformance?.awardedIdeasLatam || 0 }}</p>
                            </div>
                        </div>
                        <span class="page-dashboard-card-title">{{ 'dashboard.performance.awardedIdeas' | translate }}</span>
                    </div>

                    <div class="page-dashboard-card page-dashboard-card-light">
                        <div class="page-dashboard-card-header align-items-start">
                            <div class="page-dashboard-card-icon">
                                <svg-icon src="assets/svg/group.svg"></svg-icon>
                            </div>
                            <strong class="page-dashboard-card-value">{{ generalPerformance?.awardedCollaborators || 0 }}</strong>
                        </div>
                        <span class="page-dashboard-card-title">{{ 'dashboard.performance.awardedCollaborators' | translate }}</span>
                    </div>
                </div>

                <!-- GANHOS: linha "Total" = REAL (generalPerformanceGainsDashboard);
                     Operações/Administrativo = ILUSTRATIVO ("—" + selo), pois ainda não há esse split no backend. -->
                <div class="page-dashboard-section mt-5">
                    <h3 class="page-dashboard-section-title"><strong>{{ 'dashboard.performance.gains.title' | translate }}</strong></h3>
                    <p class="page-dashboard-section-note">{{ 'dashboard.performance.realVsMockNote' | translate }}</p>

                    <div class="page-dashboard-gains">
                        <div class="page-dashboard-gains-column" *ngFor="let col of gainsColumns">
                            <div class="page-dashboard-gains-header">
                                <span class="page-dashboard-gains-icon"><svg-icon [src]="col.icon"></svg-icon></span>
                                <strong>{{ col.titleKey | translate }}</strong>
                            </div>

                            <div class="page-dashboard-gains-card" *ngFor="let item of col.items"
                                 [class.page-dashboard-gains-card-mock]="!item.field">
                                <svg-icon [src]="item.icon"></svg-icon>

                                <div class="page-dashboard-gains-card-info">
                                    <ng-container *ngIf="item.field; else gainsMock">
                                        <strong *ngIf="item.format === 'currency'">{{ gainsValue(item) | currency:'BRL':'symbol':'1.2-2' }}</strong>
                                        <strong *ngIf="item.format !== 'currency'">{{ gainsValue(item) | number:'1.0-2' }}</strong>
                                        <span *ngIf="item.suffixKey">{{ item.suffixKey | translate }}</span>
                                    </ng-container>
                                    <ng-template #gainsMock><strong>—</strong></ng-template>
                                </div>

                                <small>
                                    {{ item.labelKey | translate }}
                                    <i class="page-dashboard-card-mock-badge page-dashboard-row-badge" *ngIf="!item.field"
                                       [attr.title]="'dashboard.committee.mockHint' | translate">{{ 'dashboard.committee.mockBadge' | translate }}</i>
                                </small>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- INVESTIMENTO: Total = REAL (investmentTotal); Operações/Administrativo e ROI = ILUSTRATIVO. -->
                <div class="page-dashboard-section page-dashboard-investment mt-4 p-4">
                    <h3 class="page-dashboard-section-title"><strong>{{ 'dashboard.performance.investment.title' | translate }}</strong></h3>

                    <div class="page-dashboard-investment-divider"></div>

                    <h4 class="page-dashboard-investment-subtitle">{{ 'dashboard.performance.investment.subtitle' | translate }}</h4>

                    <div class="page-dashboard-investment-list">
                        <div class="page-dashboard-investment-item" *ngFor="let item of investmentList"
                             [class.page-dashboard-investment-item-mock]="!item.field">
                            <svg-icon [src]="item.icon"></svg-icon>

                            <div>
                                <strong *ngIf="item.field; else investmentMock">{{ gainsValue(item) | currency:'BRL':'symbol':'1.2-2' }}</strong>
                                <ng-template #investmentMock><strong>—</strong></ng-template>
                                <em class="page-dashboard-investment-roi">
                                    {{ 'dashboard.performance.investment.roi' | translate }} —
                                    <i class="page-dashboard-card-mock-badge page-dashboard-row-badge"
                                       [attr.title]="'dashboard.committee.mockHint' | translate">{{ 'dashboard.committee.mockBadge' | translate }}</i>
                                </em>
                            </div>

                            <small>
                                {{ item.labelKey | translate }}
                                <i class="page-dashboard-card-mock-badge page-dashboard-row-badge" *ngIf="!item.field"
                                   [attr.title]="'dashboard.committee.mockHint' | translate">{{ 'dashboard.committee.mockBadge' | translate }}</i>
                            </small>
                        </div>
                    </div>
                </div>

                <!-- 3a) DESEMPENHO POR UNIDADE -->
                <div class="d-block mt-5">
                    <h3 class="text-primary"><strong>{{ 'dashboard.performance.byUnityTitle' | translate }}</strong></h3>

                    <div class="page-dashboard-chart-wrap">
                        <google-chart
                                class="my-4"
                                style="width: 100%; display: block;"
                                [type]="byUnityChart.type"
                                [data]="byUnityChart.data"
                                [columns]="byUnityChart.columns"
                                [options]="byUnityChart.options"
                                [dynamicResize]="true">
                        </google-chart>
                    </div>

                    <div class="page-dashboard-table-scroll" *ngIf="byUnity?.items?.length">
                        <table class="page-dashboard-matrix-table">
                            <thead>
                                <tr>
                                    <th></th>
                                    <th *ngFor="let it of byUnity?.items">{{ it.unityName }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{{ 'dashboard.performance.rowRegistered' | translate }}</td>
                                    <td *ngFor="let it of byUnity?.items">{{ it.ideasRegistered }}</td>
                                </tr>
                                <tr>
                                    <td>{{ 'dashboard.performance.rowAwarded' | translate }}</td>
                                    <td *ngFor="let it of byUnity?.items">{{ it.awardedIdeas }}</td>
                                </tr>
                                <tr>
                                    <td>{{ 'dashboard.performance.rowCollaborators' | translate }}</td>
                                    <td *ngFor="let it of byUnity?.items">{{ it.awardedCollaborators }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <!-- 3b) BRASIL -->
                <div class="d-block mt-5">
                    <h3 class="text-primary"><strong>{{ 'dashboard.performance.brazil' | translate }}</strong></h3>
                    <div class="page-dashboard-chart-wrap" *ngIf="hasMonthlyData(brazilChart)">
                        <google-chart
                                class="my-4"
                                style="width: 100%; display: block;"
                                [type]="brazilChart.type"
                                [data]="brazilChart.data"
                                [columns]="brazilChart.columns"
                                [options]="brazilChart.options"
                                [dynamicResize]="true">
                        </google-chart>
                    </div>
                    <p class="page-dashboard-empty" *ngIf="brazilMonthly && !hasMonthlyData(brazilChart)">
                        {{ 'dashboard.performance.noData' | translate }}
                    </p>
                </div>

                <!-- 3c) LATAM -->
                <div class="d-block mt-5">
                    <h3 class="text-primary"><strong>{{ 'dashboard.performance.latam' | translate }}</strong></h3>
                    <div class="page-dashboard-chart-wrap" *ngIf="hasMonthlyData(latamChart)">
                        <google-chart
                                class="my-4"
                                style="width: 100%; display: block;"
                                [type]="latamChart.type"
                                [data]="latamChart.data"
                                [columns]="latamChart.columns"
                                [options]="latamChart.options"
                                [dynamicResize]="true">
                        </google-chart>
                    </div>
                    <p class="page-dashboard-empty" *ngIf="latamMonthly && !hasMonthlyData(latamChart)">
                        {{ 'dashboard.performance.noData' | translate }}
                    </p>
                </div>

                <!-- 3d) LISTA DE PREMIADAS -->
                <div class="page-dashboard-idea-list">
                    <div class="page-dashboard-idea-header">
                        <h3 class="page-dashboard-idea-title">{{ 'dashboard.performance.awardedListTitle' | translate }}</h3>
                        <span class="page-dashboard-idea-total">{{ awardedList?.totalCount || 0 }}</span>
                    </div>

                    <div class="page-dashboard-idea-divider"></div>

                    <div class="page-dashboard-table-scroll">
                        <table class="page-dashboard-awarded-table">
                            <!-- larguras fixas por coluna (table-layout: fixed): texto longo quebra na própria célula -->
                            <colgroup>
                                <col class="col-code">
                                <col class="col-title">
                                <col class="col-committee">
                                <col class="col-unity">
                                <col class="col-name">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th>{{ 'dashboard.committee.cols.code' | translate }}</th>
                                    <th>{{ 'dashboard.committee.cols.title' | translate }}</th>
                                    <th>{{ 'committee' | translate }}</th>
                                    <th>{{ 'dashboard.committee.cols.unity' | translate }}</th>
                                    <th>{{ 'dashboard.performance.colName' | translate }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let idea of awardedList?.results; let i = index" [class.striped]="i % 2 !== 0">
                                    <td>{{ idea.code }}</td>
                                    <td>{{ idea.title }}</td>
                                    <td>{{ idea.committeeName }}</td>
                                    <td>{{ idea.unityName }}</td>
                                    <td>{{ idea.authorName }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div class="page-dashboard-idea-pagination d-flex align-items-center justify-content-end mt-3"
                         *ngIf="awardedList">
                        <button type="button" class="btn btn-sm btn-outline-primary mr-2"
                                [disabled]="!awardedList.previouPage" (click)="prevAwardedPage()">‹</button>
                        <span class="mx-2">{{ awardedList.currentPage }} / {{ awardedList.totalPage }}</span>
                        <button type="button" class="btn btn-sm btn-outline-primary ml-2"
                                [disabled]="!awardedList.nextPage" (click)="nextAwardedPage()">›</button>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>